import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createSalesmanEntry = createAsyncThunk('createSalesmanEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSalesman`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updatePartyEntry = createAsyncThunk('updatePartyEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateParty`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSalesmanData = createAsyncThunk('fetchSalesmanData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getsalesmanlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleParty = createAsyncThunk('fetchSingleParty', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPartylist&partyId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleSalesman = createAsyncThunk('deleteSingleSalesman', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deletesalesman&salesmanId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const salesmanSlice = createSlice({
    name: 'SalesmanData',
    initialState: {
        isLoading: false,
        salesman: null,
        deleteSalesman: null,
        singleParty: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSalesmanData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSalesmanData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.salesman = action.payload;
        });
        builder.addCase(fetchSalesmanData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleSalesman.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleSalesman.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteSalesman = action.payload;
        });
        builder.addCase(deleteSingleSalesman.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleParty.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleParty.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleParty = action.payload;
        });
        builder.addCase(fetchSingleParty.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default salesmanSlice.reducer;
